import styled from 'styled-components';
import { InfoIcon } from '@rsos/assets/icons';

export const StyledBubble = styled.div<{
  theme: object;
  width?: string;
  appearance: 'inverted' | 'matched';
}>`
  position: absolute;
  color: ${({ theme, appearance }) =>
    appearance === 'inverted'
      ? theme.colors.background
      : theme.colors.primaryText};
  background-color: ${({ theme, appearance }) =>
    appearance === 'inverted'
      ? theme.colors.primaryText
      : theme.colors.background};
  border: ${({ theme, appearance }) =>
    appearance === 'inverted'
      ? 'none'
      : `1px solid ${theme.colors.heavyLineOutline}`};
  padding: 10px;
  border-radius: 5px;
  font-size: 0.8em;
  width: ${({ width }) => (width ? width : '250px')};
`;

export const StyledIconButton = styled.div.attrs({ role: 'button' })`
  display: inline-block;
  margin: 0 0 0 0.2em;
  outline: 0;
  border: 0;
  font-size: 1em;
  position: relative;
  top: 0.12em;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryLink};
`;

export const StyledInfoIcon = styled(InfoIcon)`
  height: 1em;
  width: 1em;
`;
